import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';
import {ExcFilter, ExcFilterCondition} from '../../../filter-sort-service.service';

@Component({
  selector: 'app-provider-modal-export-audit',
  templateUrl: './provider-modal-export-audit.component.html',
  styles: []
})
export class ProviderModalExportAuditComponent extends ExcTranslation implements OnInit {
  clients: any[] = [];
  selected = {AuditMonth: 0 , AuditYear: (new Date()).getFullYear(), AuditStatus: 0 , mandant: 0};
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  status: any[] = [];
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    const _self = this;
    _self.optionsMonth.push({text: 'Alle', value: 0});
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
    _self.status.push({value: 0, text: _self.getGlobal('SelectAll') });
    _self.status.push({value: 1, text: _self.getGlobal('AuditState_' + 1 ) });
    _self.status.push({value: 2, text: _self.getGlobal('AuditState_' + 2 ) });
    _self.status.push({value: 3, text: _self.getGlobal('AuditState_' + 3 ) });
    _self.status.push({value: 4, text: _self.getGlobal('AuditState_' + 4 ) });
    _self.status.push({value: 8, text: _self.getGlobal('AuditState_' + 8 ) });
    _self.status.push({value: 10, text: _self.getGlobal('AuditState_' + 10 ) });
  }

  ngOnInit() {
    const _self = this;
    _self.clients = _self.overlayConfig.data.Client;
  }
  export() {
    const _self = this;
    if (_self.selected.AuditMonth === 0) {
      _self.selected.AuditMonth  = null;
    }
    if (_self.selected.mandant === 0) {
      _self.selected.mandant  = null;
    }
    if (_self.selected.AuditStatus === 0) {
      _self.selected.AuditStatus  = null;
    }
    _self.overlayRef.close({proceed: true, selected: _self.selected});
  }

}
